export enum FeedbackType {
	error = 'error',
	info = 'info',
	success = 'success',
	warning = 'warning',
}